import { BaseService } from "./baseService";
import { UserDto, userFormData } from "../types/user";

class UserService extends BaseService<UserDto,typeof userFormData> {
  constructor() {
    super("/User");
  }
  async getByUsername(username: string) {
    return await this.getAll({ username });
  }
}

export const userService = new UserService();
